//Right click context menu for editing edges or bringing up quick-menu items.

import React, { useRef, useEffect, useState } from 'react';
import './contextmenu.css'

function ContextMenu({rightClickItem, position, offset, isLeft, isTop, isToggled, buttons}) {
    const menuRef = useRef(null);
    const [menuDimensions, setMenuDimensions] = useState({ width: 0, height: 0 });
    
    useEffect(() => {
      if (menuRef.current) {
        const { offsetWidth, offsetHeight } = menuRef.current;
        setMenuDimensions({ width: offsetWidth, height: offsetHeight });
      }
    }, [isToggled, buttons]);

    let topPos = position.y + offset.y;
    let leftPos = position.x + offset.x;
    
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    if (leftPos + menuDimensions.width > viewportWidth) {
      leftPos = viewportWidth - menuDimensions.width - offset.x;
    }

    if (topPos + menuDimensions.height > viewportHeight) {
      topPos = viewportHeight - menuDimensions.height - offset.y;
    }

  return (
    <div ref={menuRef} className='contextmenu' style={{top:`${topPos}px`, left:`${leftPos}px`, visibility:isToggled ? 'visible' : 'hidden'}} >
      {buttons.map((button, index) => {
        return <button className='contextmenu-button' key={index} onClick={button.func}>{button.name}</button>
      })} 
    </div>
  );
}

export default ContextMenu;